"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Calls all dispose functions in the disposables list in the opposite order and empties the list.
 * @param disposables
 */
function disposeAll(disposables) {
  while (disposables.length) {
    disposables.pop()();
  }
}

var _default = disposeAll;
exports.default = _default;